/* ==========================================================================
   IRON CREST LEATHER — collection.js
   One job: sorting the collection grid. Everything else on these pages is
   markup the homepage already styles, and the cart is still product-card.js.

   Shopify: on a real store, sort is a URL parameter that the server answers
   (`?sort_by=price-ascending`), so this becomes a form that submits. The DOM
   reorder here is the static-prototype stand-in; the markup hooks are the same.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var grid = document.querySelector('[data-collection-grid]');
    var select = document.querySelector('[data-sort]');
    if (!grid || !select) return;
    if (grid.icBooted) return;   // already live; the editor replaced a different section
    grid.icBooted = true;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    var featured = cards.slice();                 // the order the page shipped in

    // the control ships hidden: a <select> that only a script can act on is worse
    // than no control at all, so it appears once there is a script to act on it
    var label = select.closest ? select.closest('.cbar__sort') : select.parentNode;
    if (label) label.hidden = false;

    function priceOf(card) {
      var el = card.querySelector('.price__now');
      if (!el) return 0;
      return parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
    }
    function nameOf(card) {
      var el = card.querySelector('.card__title');
      return el ? el.textContent.trim().toLowerCase() : '';
    }

    var SORTS = {
      'featured':   function () { return featured.slice(); },
      'price-asc':  function () { return cards.slice().sort(function (a, b) { return priceOf(a) - priceOf(b); }); },
      'price-desc': function () { return cards.slice().sort(function (a, b) { return priceOf(b) - priceOf(a); }); },
      'name':       function () { return cards.slice().sort(function (a, b) { return nameOf(a) < nameOf(b) ? -1 : 1; }); }
    };

    select.addEventListener('change', function () {
      var next = (SORTS[select.value] || SORTS.featured)();
      var frag = document.createDocumentFragment();
      next.forEach(function (c, i) {
        c.style.setProperty('--i', i);
        frag.appendChild(c);                      // moving a node re-parents it
      });
      grid.appendChild(frag);

      // reuse the homepage's stagger so a re-sort reads as one considered move
      grid.classList.remove('is-sorted');
      void grid.offsetWidth;
      grid.classList.add('is-sorted');
    });
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
